import { addListenersNaming } from './update/listeners-naming.js'

export function enableListeners (DOMelement, browserAppAccount) {
  addListenersNaming(DOMelement, browserAppAccount)

  // const accountId = accountData.id || accountData._id
  //   DOMelement.addEventListener('click', function (clickEvent) {
  //     const clickedElement = clickEvent.target.closest('#togglePublic')
  //     if (!clickedElement) return

//     const isPublic = clickedElement.getAttribute('d-isPublic')
//     togglePublic({ accountId, isPublic })
//   })
}

// async function togglePublic (params) {
//   console.log('togglePublic', params)
//   const { accountId, isPublic } = params

//   const apiUrl = '/api/account/:accountId/togglePublic/:isPublic'
//   await callApi(apiUrl, {
//     accountId,
//     isPublic
//   }, {
//     method: 'PUT'
//   })

//   reloadAccountDetails(accountId)
// }
